import React, { useEffect, useRef } from 'react';
import './users.css';
import Header from "../../components/Header/Header";
import UsersHeader from "../../components/PagesHeaders/UsersHeader/UsersHeader";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from 'react-router-dom';
import {
    getUserInfoSagaAction,
    getUsersForSubscriptionSagaAction,
    getUsersStatisticSagaAction
} from "../../redux/sagaActions";
import UserForm from "../../components/UserForm/UserForm";
import UserPhoto from "../../components/UserPhoto/UserPhoto";
import { currentUserAction, dropdownAction, usersAction } from "../../redux/rootReducer";
import CurrentUser from "../../components/CurrentUser/CurrentUser";
import UsersStats from "../../components/UsersStats/UsersStats";
import SubscriptionForm from "../../components/SubscriptionForm/SubscriptionForm";
import AddSubscriptionForm from "../../components/AddSubscriptionForm/AddSubscriptionForm";
import SubscriptionCalendar from "../../components/SubscriptionCalendar/SubscriptionCalendar";
import ExtendSubscriptionForm from "../../components/ExtendSubscriptionForm/ExtendSubscriptionForm";
import KeyForm from "../../components/KeyForm/KeyForm";
import UsersList from "../../components/UsersList/UsersList";
import RepayMoneyForm from "../../components/RepayMoneyForm/RepayMoneyForm";
import FamilyForm from "../../components/FamilyForm/FamilyForm";
import { CURRENT_USER_INITIAL } from "../../redux/initialStateConstant";
import ChangeUserEmailForm from "../../components/ChangeUserEmailForm/ChangeUserEmailForm";

const Users = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const search = useSelector(state => state.search);
    const currentUser = useSelector(state => state.currentUser);
    const currentEstablishment = useSelector(state => state.currentEstablishment);
    const usersList = useSelector(state => state.usersList);
    const addSubscriptionForm = useSelector(state => state.addSubscriptionForm);
    const change_user_email_form = useSelector(state => state.change_user_email_form);

    // Таймер для отсрочки запроса посетителей на сервере
    const timer = useRef(0);

    const getUsers = text => {

        if (timer.current) clearTimeout(timer.current);

        // Делаем задержку для набора текста
        timer.current = setTimeout(() => {
            // Получение списка пользователей, удовлетворяющих введённым данным (имя, телефон, почта)
            dispatch(getUsersForSubscriptionSagaAction({ text, type: 'specific_user' }));
        }, 500);
    };

    // Получение информации о конкретном пользователе
    useEffect(() => {
        if (search) {
            getUsers(search);
        }
        else {
            clearTimeout(timer.current);
            dispatch(usersAction([]));
            dispatch(dropdownAction(null));
            dispatch(currentUserAction(CURRENT_USER_INITIAL));
        }
    }, [search]);

    // Получение информации по всем пользователям
    useEffect(() => {
        if (id) {
            dispatch(getUserInfoSagaAction({ id }));
        }
        else {
            if (!currentEstablishment) return;
            dispatch(getUsersStatisticSagaAction({ establishment: currentEstablishment }));
        }

    }, [currentEstablishment, id]);

    return (
        <>
            <Header component={ <UsersHeader /> } />
            { change_user_email_form.open && <ChangeUserEmailForm/> }
            <UserForm/>
            <UserPhoto/>
            <KeyForm/>
            <div className="page">
                <SubscriptionForm />
                { addSubscriptionForm.open && <AddSubscriptionForm/> }
                <SubscriptionCalendar />
                <ExtendSubscriptionForm />
                <RepayMoneyForm/>
                <FamilyForm/>
                {
                    currentUser.id
                        ? <CurrentUser/>
                        :
                        usersList.length
                        ?
                            <UsersList/>
                        :
                            <UsersStats/>
                }
            </div>
        </>
    );
};

export default Users;